import React from 'react'

interface SalonContactProps {
  // Predates react-hook-form v7's registration API: `form.register` is used
  // directly as a plain `ref` instead of spread. Typed loosely since v7's
  // `UseFormReturn.register` ref signature doesn't match this v6-style usage.
  form: any;
}

const SalonContact = ({ form }: SalonContactProps) => {
  return (
    <>
      <input hidden name='shopId' ref={form.register} type="text" placeholder='Please enter...' />
      <input hidden name='companyName' ref={form.register} type="text" placeholder='Please enter...' />
      <div className="salon-information-input-container">
        <span className="label-input">Facebook Link</span>
        <input name='facebookUrl' ref={form.register} type="text" placeholder='Please enter...' />
      </div>
      <div className="salon-information-input-container">
        <span className="label-input">Instagram Link</span>
        <input name='instagramUrl' ref={form.register} type="text" placeholder='Please enter...' />
      </div>
      <div className="salon-information-input-container">
        <span className="label-input">Google Link</span>
        <input name='googleUrl' ref={form.register} type="text" placeholder='Please enter...' />
      </div>
      <div className="salon-information-input-container">
        <span className="label-input">Yelp Link</span>
        <input name='yelpUrl' ref={form.register} type="text" placeholder='Please enter...' />
      </div>
      <div className="salon-information-input-container">
        <span className="label-input">Street</span>
        <input name='address' ref={form.register} type="text" placeholder='Please enter...' />
      </div>
      <div className="salon-information-input-container">
        <span className="label-input">City</span>
        <input name='city' ref={form.register} type="text" placeholder='Please enter...' />
      </div>
      <div className="salon-information-input-container">
        <span className="label-input">State</span>
        <input name='state' ref={form.register} type="text" placeholder='Please enter...' />
      </div>
      <div className="salon-information-input-container">
        <span className="label-input">Zip Code</span>
        <input name='zip' ref={form.register} type="text" placeholder='Please enter...' />
      </div>
    </>
  )
}

export default SalonContact;
